<template>
  <card
    style="height: 100%;"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <div class="device-picker" style="position: relative;left: 20px;">
      - 气象墒情
    </div>

    <div class="weather-data-wrap">
      <!-- <div v-if="empty" class="no-data">暂无数据</div> -->
      <div class="weather-data__card" v-for="col in cards" :key="col.key">
        <div class="weather-data__container" :style="{ background: col.bg }">
          <div class="card__value">
            <div class="value">
              <span>{{ col.value }}</span>

              <div class="unit">
                <span>{{ col.unit }}</span>
              </div>
            </div>

            <div class="label">
              <span>{{ col.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="device-picker" style="position: relative;left: 20px;">
      - 变化趋势
    </div>

    <echart
      chartId="meteorology"
      :options="options"
      :height="height - 250"
    ></echart>
  </card>
</template>

<script>
import mixin from '../mixin'
import Card from '../card'
import Echart from '@/components/Chart'
import { list, cols } from '@/service/meteorology'
import { subtract, add } from '@/utlis/date'
import { getIcon, colors } from '@/utlis/meteorology'
import sleep from '@/utlis/sleep'

const COLS = [
  { key: 'e1', name: '风速', card: 1 },
  { key: 'e7', name: '风向', card: 1 },
  { key: 'e3', name: '大气温度', card: 1, x: 0, y: 0, type: 'line' },
  { key: 'e9', name: '大气湿度', card: 1, x: 0, y: 0, type: 'line' },
  { key: 'e2', name: '降雨量', card: 1, x: 0, y: 1, type: 'bar' },
  { key: 'e4', name: '日雨' },
  { key: 'e6', name: '土壤温度', card: 1, x: 1, y: 2, type: 'line' },
  { key: 'e10', name: '土壤湿度', card: 1, x: 1, y: 2, type: 'line' },
  { key: 'e5', name: '数字气压', card: 1, x: 2, y: 3, type: 'line' },
  { key: 'e11', name: '照度', card: 1, x: 3, y: 4, type: 'line' }
]

export default {
  mixins: [mixin],
  components: { Card, Echart },
  props: { weatherKey: String, airKey: String },
  data() {
    return {
      loadingCols: false, // 初始化列数据
      loading: false,
      cols: [],
      data: {
        dataset: { source: [] },
        series: []
      },
      last: []
    }
  },
  computed: {
    dev() {
      return this.metes.find(m => m.id === this.deviceId)
    },
    deviceId() {
      if (this.weatherKey) {
        const dev = this.metes.find(m => m.key === this.weatherKey)
        return dev && dev.id
      } else {
        return ''
      }
    },
    cards() {
      return COLS.filter(c => c.card).map((k, index) => {
        const col = this.cols.find(c => c.name === k.name)
        const last = this.last.find(l => l.name === k.name)
        return {
          ...col,
          value: (last && last.value) || 0,
          bg: colors[index % colors.length]
        }
      })
    },
    options() {
      let axis = [0, 1, 2, 3]
      return {
        legend: {
          show: false,
          type: 'scroll',
          left: 52,
          right: '6%',
          bottom: 18,
          pageButtonGap: 20,
          textStyle: { color: '#9aa8d4' },
          pageTextStyle: { color: '#dcdfe6', fontSize: 14 }
        },
        tooltip: {
          transitionDuration: 0,
          formatter: params => {
            const date = params[0].value.date
            let htm = date
            params.forEach(
              ({ marker, dimensionNames, encode, seriesName, value }) => {
                htm += `</br> ${marker} ${seriesName}`
                const col = this.cols.find(c => c.name === seriesName)
                const unit = col ? col.unit : ''

                if (!value) {
                  htm += ': -'
                } else {
                  htm += `: ${value[dimensionNames[encode.y[0]]]} ${unit}`
                }
              }
            )
            return htm
          }
        },
        grid: axis.map(i => {
          let height = Math.floor((100 - 4) / axis.length)
          let top = 4 + i * height
          let bottom = 100 - (top + height - 8)
          return {
            left: 44,
            right: 32,
            top: `${top}%`,
            bottom: `${bottom}%`
          }
        }),
        xAxis: axis.map(idx => {
          return {
            type: 'time',
            gridIndex: idx,
            splitLine: false,
            axisLabel: { color: '#9aa8d4' }
          }
        }),
        yAxis: [
          { gridIndex: 0, splitLine: { show: false } },
          { gridIndex: 0, splitLine: { show: false }, name: 'mm', nameGap: 4 },
          { gridIndex: 1, splitLine: { show: false } },
          { gridIndex: 2, splitLine: { show: false }, name: 'hPa', nameGap: 4 },
          {
            gridIndex: 3,
            splitLine: { show: false },
            name: 'lux',
            nameGap: 4,
            axisLabel: {
              formatter: function(value) {
                return Math.ceil(value / 1000) + 'k'
              }
            }
          }
        ],
        ...this.data
      }
    }
  },
  async mounted() {
    if (this.deviceId) {
      await this.getCols()
      this.loading = true
      const [data] = await Promise.all([this.getData(), sleep(2)])
      this.data = data
      this.loading = false
    }
  },
  methods: {
    async getCols() {
      if (this.deviceId) {
        this.loadingCols = true
        const { data } = await cols(this.deviceId)
        this.cols = data
        this.loadingCols = false
      }
    },
    async getData() {
      if (!this.deviceId) {
        return
      }
      const [{ data }, last] = await Promise.all([
        list({
          companyId: this.companyId,
          deviceId: this.deviceId,
          begin: subtract(undefined, 1, 'days', 'YYYY-MM-DD 00:00:00'),
          end: add(undefined, 1, 'days', 'YYYY-MM-DD 00:00:00'),
          type: 'day'
        }),
        this.getCurData()
      ])

      this.last = last
      const keys = data.length ? this.getKeys() : []

      return {
        dataset: {
          // dimensions: ['date'].concat(keys.map(c => c.key)),
          source: data
        },
        series: keys.map(k => {
          const card = this.cards.find(o => o.key === k.key)
          return {
            type: k.type,
            name: k.name,
            xAxisIndex: k.xIndex,
            yAxisIndex: k.yIndex,
            symbol: 'none',
            color: card ? card.bg : '#fff',
            z: k.z || 2,
            dimensions: ['date'].concat(k.key)
          }
        })
      }
    },
    async getCurData() {
      const { data } = await list({
        companyId: this.companyId,
        deviceId: this.deviceId,
        type: 'last'
      })

      return this.cols.map(c => {
        let icon = getIcon(c.name)
        return {
          ...c,
          icon: icon.icon,
          color: icon.color,
          value: data[c.key] || '-'
        }
      })
    },
    getKeys() {
      return COLS.filter(c => Boolean(c.type)).map(o => {
        const col = this.cols.find(c => c.name === o.name)
        return {
          key: col.key,
          type: o.type,
          name: o.name,
          xIndex: o.x,
          yIndex: o.y
        }
      })
    }
  },
  watch: {
    async deviceId() {
      await this.getCols()
      this.loading = true
      const [data] = await Promise.all([this.getData(), sleep(2)])
      this.data = data
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
$height: 48px;
.weather-data-wrap {
  position: relative;
  top: 32px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-left: 20px;
  box-sizing: border-box;
  &:not(:last-child) {
    margin-bottom: 1.5rem;
  }
  .no-data {
    height: 112px;
    min-height: 112px;
    line-height: 112px;
  }
}
.weather-data__card {
  width: 33%;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // height: 100%;
  color: #ffffff;
  // color: '#232E44';
  padding: 0 20px 12px 0;
}
.weather-data__card:not(:last-child) {
  // padding-right: 8px;
}
.weather-data__container {
  display: flex;
  align-items: center;
  width: 100%;
  height: $height;
  background: #6ebaff;
  border-radius: 3px;
  position: relative;
  overflow: hidden;
  &:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0.1;
    background-color: #ffffff;
  }
  &:after {
    content: '';
    background: url('~@/assets/images/card-bg.png') no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 17px;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}
.card__value {
  flex: 1;
  width: 100%;
  height: $height;
  padding: 4px;
  box-sizing: border-box;
  span {
    user-select: none;
  }
}
.label {
  text-align: center;
  padding-left: 4px;
  height: 20px;
  span {
    display: inline-block;
    text-align: left;
    font-size: 14px;
    line-height: 20px;
  }
}
.value {
  text-align: center;
  white-space: nowrap;
  span {
    color: '#232E44';
    font-size: 1rem;
  }
  .unit {
    display: inline-block;
    padding-left: 0.1rem;
    align-items: flex-end;
    span {
      font-size: 14px;
      line-height: 20px;
    }
    &.top {
      align-self: flex-start;
    }
  }
}
</style>
